import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const surveyAssetsAdapter = createEntityAdapter({})

const initialState = surveyAssetsAdapter.getInitialState()

export const surveyAssetsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getSurveyAssets: builder.query({
            query: () => ({
                url: '/surveyassets',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedsurveyassets = responseData.map(surveyasset => {
                    surveyasset.id = surveyasset._id
                    return surveyasset
                });
                return surveyAssetsAdapter.setAll(initialState, loadedsurveyassets)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'SURVEYASSET', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'SURVEYASSET', id }))
                    ]
                } else return [{ type: 'SURVEYASSET', id: 'LIST' }]
            }
        }),
        addNewSurveyAsset: builder.mutation({
            query: initialUserData => ({
                url: '/surveyassets',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'SURVEYASSET', id: "LIST" }
            ]
        }),
        updateSurveyAsset: builder.mutation({
            query: initialUserData => ({
                url: '/surveyassets',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'SURVEYASSET', id: arg.id }
            ]
        }),
        deleteSurveyAsset: builder.mutation({
            query: initialUserData => ({
                url: '/surveyassets',
                method: 'DELETE',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'SURVEYASSET', id: arg.id }
            ]
        }),
    }),   
})

export const {
    useGetSurveyAssetsQuery,
    useAddNewSurveyAssetMutation,
    useUpdateSurveyAssetMutation,
    useDeleteSurveyAssetMutation
} = surveyAssetsApiSlice;